
/* 
------NOTE----- 
The below map has to be populated whenever a new field is added to the sales table in Airtable.
Otherwise, the field will not be rendered in console.

TODO: Get this via backend API.
*/

import type { FieldsConfig } from './types';

export const fieldsToRenderIndonesia: FieldsConfig = {
  fldqszPvEFt3icxP5: {
    name: 'Sales Stage',
    width: 200,
    sort: {
      type: 'priority',
      priority: {
        Lead: 1,
        '1st Visit Done': 2,
        '2nd Visit Done': 3,
        'Closed-Lost': 4,
        'Closed-Won': 5,
      },
    },
  },
  fldnLnaGsZ9K95nGT: {
    name: 'Update Link',
    width: 150,
    sort: null,
  },
  fldcrd4AbxwboQ4sv: {
    name: 'Agronomist',
    width: 250,
    sort: null,
  },
  fldSOdSlLPJP1yhSo: {
    name: 'Type of Deal',
    width: 150,
    sort: {
      type: 'default',
    },
  },
  fldedhcKmYRXrymuZ: {
    name: 'Farmer Group Leader',
    width: 200,
    sort: {
      type: 'default',
    },
  },
  fldSoBCmM59jRntH0: {
    name: 'Farmer Group Name',
    width: 200,
    sort: {
      type: 'default',
    },
  },
  fld5vAW9afHjqIGHd: {
    name: 'Activity Age',
    width: 150,
    sort: {
      type: 'default',
    },
  },
  fld2QgMweuZsDVzb2: {
    name: 'Farmer Meeting Done',
    width: 200,
    sort: null,
  },
  fldPMJh3a0eqeLPcI: {
    name: 'Forecast Ha',
    width: 150,
    sort: {
      type: 'default',
    },
  },
  fld5XGk84zhbkUiu8: {
    name: 'Closed Ha',
    width: 150,
    sort: {
      type: 'default',
    },
  },
  fld9GswYd8IlGSgKS: {
    name: 'Closed Lost/Won Reason',
    width: 300,
    sort: {
      type: 'default',
    },
  },
  fld7AbA5LHs09OSI8: {
    name: 'Notes',
    width: 300,
    sort: {
      type: 'default',
    },
  },
  fldnrwPmRMZenr4qV: {
    name: 'Paddy Buyer',
    width: 200,
    sort: {
      type: 'default',
    },
  },
  fldrPuwR11Omel1rx: {
    name: 'EPD',
    width: 150,
    sort: {
      type: 'default',
    },
  },
  fldzWIoj5qy0FWwK5: {
    name: 'Lead Age',
    width: 150,
    sort: {
      type: 'default',
    },
  },
  fldBazpRW2UsJ8Xy4: {
    name: 'Contract Picture',
    width: 290,
    sort: null,
  },
  fld4DXrgoJOK3DfOu: {
    name: 'Farmer Meeting Picture',
    width: 290,
    sort: null,
  },
};

export const fieldsToRenderVietnam: FieldsConfig = {
  fldqszPvEFt3icxP5: {
    name: 'Sales Stage',
    width: 200,
    sort: {
      type: 'priority',
      priority: {
        Lead: 1,
        '1st Visit Done': 2,
        '2nd Visit Done': 3,
        'Closed-Lost': 4,
        'Closed-Won': 5,
      },
    },
  },
  fldnLnaGsZ9K95nGT: {
    name: 'Update Link',
    width: 150,
    sort: null,
  },
  fldcrd4AbxwboQ4sv: {
    name: 'Agronomist',
    width: 250,
    sort: null,
  },
  fldSOdSlLPJP1yhSo: {
    name: 'Type of Deal',
    width: 150,
    sort: {
      type: 'default',
    },
  },
  fldedhcKmYRXrymuZ: {
    name: 'Farmer Group Leader',
    width: 200,
    sort: {
      type: 'default',
    },
  },
  fldSoBCmM59jRntH0: {
    name: 'Farmer Group Name',
    width: 200,
    sort: {
      type: 'default',
    },
  },
  fld5vAW9afHjqIGHd: {
    name: 'Activity Age',
    width: 150,
    sort: {
      type: 'default',
    },
  },
  fld2QgMweuZsDVzb2: {
    name: 'Farmer Meeting Done',
    width: 200,
    sort: null,
  },
  fldPMJh3a0eqeLPcI: {
    name: 'Forecast Ha',
    width: 150,
    sort: {
      type: 'default',
    },
  },

  fldU807Xf002deWXg: {
    name: 'Forecast AWD Ha (Total)',
    width: 150,
    sort: {
      type: 'default',
    },
  },

  fld5XGk84zhbkUiu8: {
    name: 'Closed Ha',
    width: 150,
    sort: {
      type: 'default',
    },
  },
  fld9GswYd8IlGSgKS: {
    name: 'Closed Lost/Won Reason',
    width: 300,
    sort: {
      type: 'default',
    },
  },
  fld7AbA5LHs09OSI8: {
    name: 'Notes',
    width: 300,
    sort: {
      type: 'default',
    },
  },
  fldnrwPmRMZenr4qV: {
    name: 'Paddy Buyer',
    width: 200,
    sort: {
      type: 'default',
    },
  },
  fldrPuwR11Omel1rx: {
    name: 'EPD',
    width: 150,
    sort: {
      type: 'default',
    },
  },
  fldzWIoj5qy0FWwK5: {
    name: 'Lead Age',
    width: 150,
    sort: {
      type: 'default',
    },
  },
  fldBazpRW2UsJ8Xy4: {
    name: 'Contract Picture',
    width: 290,
    sort: null,
  },
  fld4DXrgoJOK3DfOu: {
    name: 'Farmer Meeting Picture',
    width: 290,
    sort: null,
  },
};

//

export const UNIQUE_IDENTIFIER = 'UserId';

export const urlFriendlyIdentifier = encodeURIComponent(
  `{${UNIQUE_IDENTIFIER}}=`,
);

export const JR_AG_TABLE_UNIQUE_IDENTIFIER = 'Email';

export const urlFriendlyJRAGIdentifier = encodeURIComponent(
  `{${JR_AG_TABLE_UNIQUE_IDENTIFIER}}=`,
);

export const AIRTABLE_COLOR_MAP = {
  cyanLight2: '#c4ecff',
  blueLight2: '#d1e2ff',
  tealLight2: '#c4f5f1',
  greenLight2: '#cef5d1',
  redLight2: '#ffd4e0',
};

export const AIRTABLE_CONFIG = {
  Indonesia: {
    bases: {
      app55trEWVUYhVZab: {
        id: 'app55trEWVUYhVZab',
        tables: {
          tblY2b2pOGFIqFls4: {
            id: 'tblY2b2pOGFIqFls4',
            fieldsToRender: fieldsToRenderIndonesia,
            userTableId: 'tblnSRqkk9KXm5uIG',
            filters: {
              'Sales Stage': {
                key: 'Sales Stage',
                options: [
                  {
                    value: '1st Visit Done',
                    label: '1st Visit Done',
                  },
                  {
                    value: '2nd Visit Done',
                    label: '2nd Visit Done',
                  },
                  {
                    value: 'Closed-Won',
                    label: 'Closed-Won',
                  },
                  {
                    value: 'Closed-Lost',
                    label: 'Closed-Lost',
                  },
                  {
                    value: 'Lead',
                    label: 'Lead',
                  },
                ],
              },
            },
            urls: {
              newLead:
                'https://airtable.com/embed/app55trEWVUYhVZab/pagNw6r8xlEVtyI7o/form',
            },
          },
        },
      },
    },
    urls: {
      sragLeadsView:
        'https://airtable.com/embed/app55trEWVUYhVZab/shrzkC6JcFCLz6D4u',
      sragOverView:
        'https://airtable.com/embed/app55trEWVUYhVZab/shrSmywsYjBN6wbEz',
      sragCalendarView:
        'https://airtable.com/embed/app55trEWVUYhVZab/shrCtFCNMGlqBAiA9',
    },
  },
  Vietnam: {
    bases: {
      app7M5bsviux3YXqj: {
        id: 'app7M5bsviux3YXqj',
        tables: {
          tblY2b2pOGFIqFls4: {
            id: 'tblY2b2pOGFIqFls4',
            fieldsToRender: fieldsToRenderVietnam,
            filters: {
              'Sales Stage': {
                key: 'Sales Stage',
                options: [
                  {
                    value: '1st Visit Done',
                    label: '1st Visit Done',
                  },
                  {
                    value: '2nd Visit Done',
                    label: '2nd Visit Done',
                  },
                  {
                    value: 'Closed-Won',
                    label: 'Closed-Won',
                  },
                  {
                    value: 'Closed-Lost',
                    label: 'Closed-Lost',
                  },
                  {
                    value: 'Lead',
                    label: 'Lead',
                  },
                ],
              },
            },
            userTableId: 'tblnSRqkk9KXm5uIG',
            urls: {
              newLead:
                'https://airtable.com/embed/app7M5bsviux3YXqj/pagNw6r8xlEVtyI7o/form',
            },
          },
        },
      },
    },
    urls: {
      sragLeadsView:
        'https://airtable.com/embed/app7M5bsviux3YXqj/shrHziPTvQ9aOZYNH',
      sragOverView:
        'https://airtable.com/embed/app7M5bsviux3YXqj/shrqrQT2IHUgcS7xj',
      sragCalendarView:
        'https://airtable.com/embed/app7M5bsviux3YXqj/shrqHDg3jq5VJ6gYw',
    },
  },
};
